import { render, staticRenderFns } from "./relocate_all_in_location.vue?vue&type=template&id=b31b53a2"
import script from "./relocate_all_in_location.vue?vue&type=script&lang=js"
export * from "./relocate_all_in_location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports